exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.labelPrice {\r\n    display: flex; justify-content: space-between; width: 100%;\r\n    padding-left: 0px;\n}\n.labelPrice .custom-control-label {\r\n    font-weight: 400;\r\n    color: #333333\n}\n.scrollTo {\r\n    color: #333333;\n}\r\n\r\n", ""]);

// exports
